<template>
<div class="demand" v-if="demand">
  <breadcrumb :items="[{ text: 'Demandas', to: '/demandas' }, { text: 'Demanda #' + demand.code, active: true }]" />
  <table>
    <tbody>
      <tr v-if="demand.category">
        <td><small>Categoria:</small></td>
        <td class="text-right">{{demand.category}}</td>
      </tr>
      <tr v-if="demand.name">
        <td><small>Cliente:</small></td>
        <td class="text-right">{{demand.name}}</td>
      </tr>
      <tr v-if="demand.cnpj">
        <td><small>CNPJ:</small></td>
        <td class="text-right">{{demand.cnpj}}</td>
      </tr>
      <tr v-if="demand.email">
        <td><small>Email:</small></td>
        <td class="text-right">{{demand.email}}</td>
      </tr>
      <tr v-if="demand.phone">
        <td><small>Telefone:</small></td>
        <td class="text-right">{{demand.phone}}</td>
      </tr>
      <tr v-if="demand.address">
        <td><small>Endereço:</small></td>
        <td class="text-right">{{demand.address}}</td>
      </tr>
      <tr v-if="demand.description">
        <td><small>Mensagem:</small></td>
        <td class="text-right"><small>{{demand.description}}</small></td>
      </tr>
    </tbody>
  </table>
</div>
</template>
<script>
import axios from 'axios'
import status_do_item from '@/data/status-do-item.json';

export default {
  name: 'Order',
  data() {
    return {
      status_do_item: status_do_item,
      demand: null
    }
  },
  computed: {
    total() {
      return this.demand.items.reduce(function(a, item) {
        return a + Number(item.total)
      }, 0);
    }
  },
  created() {
    axios.get('demands/' + this.$route.params.id).then(response => {
      this.demand = response.data
    }).catch(this.showError)
  },
  methods: {
    demandTotal(demand) {
      return demand.items.reduce((a, b) => {
        return a + b.total
      }, 0)
    },
    changeStatus() {
      axios.put('demands/'+this.demand._id, {items: this.demand.items}).then(response => {
        if (response.data) {
          this.notify("Status atualizado com sucesso!")
        }
      }).catch(this.showError)
    }
  }
};
</script>
